import { network } from 'services/network';
import { useMutation } from 'react-query';

const updateCardLaneIdData = (params) => {
    return network
        .post('api/bo/changeCardLane', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};
export const useMutationUpdateCardLaneIdData = () => {
    return useMutation<string, QueryError, IUpdateCardLaneIdDataPayload>((params) => updateCardLaneIdData(params));
};

interface IUpdateCardLaneIdDataPayload {
    id: string;
    laneId?: string;
    isVirtual: boolean;
    versionId: number;
}